import * as types from "./mutation_types";

export default {
  [types.INSCRIPTION_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.INSCRIPTION_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.INSCRIPTION_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.INSCRIPTION_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
